import { compose } from 'recompose';
import withE2EProp from '../../withE2EProp';
import centeredQuestion from '../hoc/centeredQuestion';
import DropdownQuestion from '../dropdown/DropdownQuestion';

export default compose(
  withE2EProp('respondent-custom-dropdown'),
  centeredQuestion,
)(DropdownQuestion);
